import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import { loadFonts } from "./plugins/webfontloader";
import "@/styles/design-system.scss";
import "@/firebase";
import { auth } from "./firebase";
import { createMetaManager } from "vue-meta";

loadFonts();
document.title = "Stichting WeShare4Kids";

// Scroll-reveal directive: fades elements up as they enter the viewport, once.
// Respects reduced-motion and degrades gracefully without IntersectionObserver.
const reveal = {
  mounted(el) {
    const prefersReduced = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;
    if (prefersReduced || typeof IntersectionObserver === "undefined") {
      el.classList.add("is-revealed");
      return;
    }
    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-revealed");
            obs.unobserve(entry.target);
          }
        });
      },
      { rootMargin: "0px 0px -80px 0px", threshold: 0.05 }
    );
    observer.observe(el);
    el._wsRevealObserver = observer;
  },
  unmounted(el) {
    if (el._wsRevealObserver) {
      el._wsRevealObserver.disconnect();
      delete el._wsRevealObserver;
    }
  },
};

let app;
auth.onAuthStateChanged((user) => {
  if (user) {
    store.commit("setUser", user);
  }
  if (!app) {
    const instance = createApp(App);
    instance.directive("reveal", reveal);
    instance
      .use(router)
      .use(createMetaManager())
      .use(vuetify)
      .use(store)
      .mount("#app");
    app = instance;
  }
});
